import { render, staticRenderFns } from "./BronchopneumoniaReportTables.vue?vue&type=template&id=ea43ef78&scoped=true&"
import script from "./BronchopneumoniaReportTables.vue?vue&type=script&lang=ts&"
export * from "./BronchopneumoniaReportTables.vue?vue&type=script&lang=ts&"
import style0 from "./BronchopneumoniaReportTables.vue?vue&type=style&index=0&id=ea43ef78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea43ef78",
  null
  
)

export default component.exports